export default "__VITE_ASSET__Bjmrco5m__"